import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService, HttpResponse } from "../http-util.service";
import { preset } from "src/app/models/sales-reports/buyers-order-report-dynamic";

@Injectable({
  providedIn: "root",
})
export class BuyersOrderReportDynamicService {
  private readonly baseUrl: string = "SalesReportService.asmx";

  constructor(private http: HttpUtilService) {}

  GetBuyersOrdersReportPreset(): Observable<HttpResponse<preset[]>> {
    return this.http.get<preset[]>(
      `${this.baseUrl}/GetBuyersOrdersReportPreset`,
    );
  }
}
